import { ref, shallowRef } from 'vue'
import { Loading } from 'element-ui'
import { getValueByPath, setValueByPath, clone } from '../../../utils/index'
import { pgMessage } from '../../message/index'
import { useForm } from './use-form'

export function useBottomTable({
  bottomParentKey,
  topRowConfig,
  bottomRowConfig,
  formItemsUrl,
  formItems,
  formItemsCode,
  formUrl,
  formParam,
  addItemsBefore,
}) {
  const bottomTableRef = ref(null)
  const bottomData = shallowRef([])
  const bottomDataSelections = shallowRef([])

  // 跟新下表数据，支持按照传入数据的顺序更新下表数据部分字段
  const updateBottomData = (data, field) => {
    const fieldData = Array.isArray(field) ? field : [{ to: field, from: field }]
    bottomDataSelections.value = []
    if (!field) {
      bottomData.value = data
    } else {
      bottomData.value = bottomData.value.map((bottom, index) => {
        for (const fieldItem of fieldData) {
          setValueByPath(bottom, fieldItem.to, getValueByPath(data[index], fieldItem.from))
        }
        return bottom
      })
    }
    bottomTableRef.value?.loadData?.(bottomData.value)
  }
  const { formRef, formData, formConfig, updateFormData, getInitFormData } = useForm({
    formItemsUrl,
    formItems,
    formItemsCode,
    formUrl,
    formParam,
    updateBottomData,
  })

  //选中时
  const bottomCheck = ({ records }) => {
    bottomDataSelections.value = records
  }
  //增加下表数据
  const addItems = async (rows, checked, upDateTopCheckbox) => {
    const loadingInstance = Loading.service({ background: 'rgba(0,0,0,0)', fullscreen: true })
    //如果addItemsBefore返回对象则会清空下表之前的数据
    const res = addItemsBefore
      ? await addItemsBefore?.({
          rows,
          checked,
          bottomData: bottomData.value,
          formData: formData.value,
        })
      : rows
    loadingInstance.close()
    if (!res) return Promise.reject()
    const { items, ...newFormData } = Array.isArray(res) ? { items: res } : res
    const isNewFormData = newFormData && Object.keys(newFormData).length > 0
    if (checked) {
      bottomData.value = [
        ...(isNewFormData ? [] : bottomData.value),
        ...(items ?? []).map((im) => clone(im)),
      ]
    } else if (bottomParentKey) {
      bottomData.value = bottomData.value.filter(
        (im) =>
          !items?.some(
            (row) =>
              getValueByPath(im, bottomParentKey) === getValueByPath(row, topRowConfig?.keyField)
          )
      )
    }
    if (isNewFormData) {
      updateFormData(newFormData)
    }
    bottomTableRef.value?.loadData?.(bottomData.value)
    if (!bottomParentKey) {
      return Promise.reject()
    } else if (addItemsBefore) {
      //当存在向下添加钩子时需要刷新上表复选框状态
      upDateTopCheckbox()
    }
  }

  //重置下表数据
  const bottomReload = () => {
    bottomData.value = []
    bottomDataSelections.value = []
    bottomTableRef.value?.loadData?.(bottomData.value)
  }
  //校验下班必填
  const bottomValidate = async () => {
    const error = await bottomTableRef.value?.fullValid?.()
    if (error) {
      pgMessage.error('请完善必填信息')
      return Promise.reject()
    }
  }
  //校验表单和表格
  const validate = async () => {
    const formErrors = await formRef.value?.validate()
    const tableError = await bottomTableRef.value?.fullValid?.()
    if (tableError || formErrors) {
      pgMessage.error('请完善必填信息！')
    }
    return tableError || formErrors
  }
  //删除下表数据
  const bottomRemoves = (rows) => {
    if (!rows?.length) {
      bottomData.value = []
      bottomDataSelections.value = []
    } else {
      bottomData.value = bottomData.value.filter(
        (im) =>
          !rows.some(
            (row) =>
              getValueByPath(im, bottomRowConfig?.keyField ?? '_ID') ===
              getValueByPath(row, bottomRowConfig?.keyField ?? '_ID')
          )
      )
      bottomDataSelections.value = bottomDataSelections.value.filter(
        (im) =>
          !rows.some(
            (row) =>
              getValueByPath(im, bottomRowConfig?.keyField ?? '_ID') ===
              getValueByPath(row, bottomRowConfig?.keyField ?? '_ID')
          )
      )
    }
    bottomTableRef.value?.loadData?.(bottomData.value)
  }
  return {
    formRef,
    formData,
    formConfig,
    getInitFormData,
    bottomTableRef,
    bottomData,
    bottomDataSelections,
    bottomCheck,
    addItems,
    bottomReload,
    bottomValidate,
    validate,
    bottomRemoves,
    updateFormData,
    updateBottomData,
  }
}
